import { EventEmitter } from "events";

export const GlobalEventEmitter = new EventEmitter();
